import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getBackofficeCustomersQueryKey } from "modules/backoffice/lib/customers/getBackofficeCustomersQuery"
import { DataResponse, UpsertBackofficeCustomerBodySchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof UpsertBackofficeCustomerBodySchema>>

type Props = {
  id: string
  onSuccess?: () => void
}

export function useEditBackofficeCustomerMutation({ id, onSuccess }: Props) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.input<typeof UpsertBackofficeCustomerBodySchema>) => {
      const response = await axios.put<Response>(`/backoffice/customers/${id}`, data)

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBackofficeCustomersQueryKey() })

      onSuccess?.()
    },
  })
}
